import { render, staticRenderFns } from "./SellerConsolidatedGoals.vue?vue&type=template&id=ca7a545c"
import script from "./SellerConsolidatedGoals.vue?vue&type=script&lang=js"
export * from "./SellerConsolidatedGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports